import React, { PropTypes } from 'react';
import Card from 'components/Card';
import cx from './Wrapper.scss';

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class Wrapper extends React.Component {

	static propTypes = {
		size: PropTypes.oneOf(['1', '2', '3', '1/2']),
		className: PropTypes.string,
	};

	static defaultProps = {
		size: '1',
	};

	render() {
		const { size, className = '', ...rest } = this.props;

		return (
			<Card
				className={`${className} ${cx('main', { [size.replace('/', '-')]: true })}`}
				{...rest}
				/>
		);
	}

}



// WEBPACK FOOTER //
// ./src/react/components/GoalCard/Wrapper.js